<template>
  <div>
    <div class="tui-tableTitle">平衡膳食五项标准：</div>
    <el-card>
      <div class="tui-tableTitle">
        1、热量摄入量占供给量85-90%为中等，90%以上为好，蛋白质占供给量80%以上。
      </div>
      <!-- 表格 -->
      <table>
        <tr>
          <th style="background: rgb(242, 245, 255)"></th>
          <th style="background: rgb(242, 245, 255)">蛋白质</th>
          <th style="background: rgb(242, 245, 255)">热量</th>
        </tr>
        <tr>
          <td>平均每人每日摄入量</td>
          <td>{{ BookInfo.ProteinAvg }}</td>
          <td>{{ BookInfo.EnergyAvg }}</td>
        </tr>
        <tr>
          <td>占平均供给量%</td>
          <td>{{ BookInfo.ProteinIntake }}</td>
          <td>{{ BookInfo.EnergyIntake }}</td>
        </tr>
      </table>
      <div class="tui-tableTitle">
        2、蛋白质、脂肪、碳水化合物比值1：1：4-5。
      </div>
      <div class="tui-tableTitle">
        3、三大营养素产热量占总热量应为:
        蛋白质12-15%\脂肪25-30%\碳水化合物50-60%
      </div>
      <table>
        <tr>
          <th style="background: rgb(242, 245, 255)"></th>
          <th style="background: rgb(242, 245, 255)">蛋白质</th>
          <th style="background: rgb(242, 245, 255)">脂肪</th>
          <th style="background: rgb(242, 245, 255)">碳水化合物</th>
        </tr>
        <tr
          v-for="(item, index) in BookInfo.threeNutritionDetails"
          :key="index"
        >
          <td>{{ item.TypeName }}</td>
          <td>{{ item.Protein }}</td>
          <td>{{ item.Fat }}</td>
          <td>{{ item.Carbohydrate }}</td>
        </tr>
      </table>
      <div class="tui-tableTitle">4、动物蛋白质+豆类蛋白质的摄入量≥50%。</div>
      <div class="tui-tableTitle">
        5、动物食品的热量+豆类食品的热量摄入量≥20%。
      </div>
      <table>
        <tr>
          <th style="background: rgb(242, 245, 255)"></th>
          <th style="background: rgb(242, 245, 255)">动物蛋白+豆类蛋白</th>
          <th style="background: rgb(242, 245, 255)">动物热量+豆类热量</th>
        </tr>
        <tr
          v-for="(item, index) in BookInfo.proteinAndEnergyDetails"
          :key="index"
        >
          <td>{{ item.TypeName }}</td>
          <td>{{ item.ProteinProportion }}</td>
          <td>{{ item.EnergyProportion }}</td>
        </tr>
      </table>
      <div class="tui-tableTitle">
        6、钙、铁、锌，以及维生素A、B1、B2、C等均应达到80％以上。
      </div>
      <table>
        <tr>
          <th style="background: rgb(242, 245, 255)"></th>
          <th style="background: rgb(242, 245, 255)">维生素A</th>
          <th style="background: rgb(242, 245, 255)">维生素B1</th>
          <th style="background: rgb(242, 245, 255)">维生素B2</th>
          <th style="background: rgb(242, 245, 255)">维生素C</th>
          <th style="background: rgb(242, 245, 255)">铁</th>
          <th style="background: rgb(242, 245, 255)">钙</th>
          <th style="background: rgb(242, 245, 255)">锌</th>
        </tr>
        <tr
          v-for="(item, index) in BookInfo.traceElementIntakeDetail"
          :key="index"
        >
          <td>{{ item.TypeName }}</td>
          <td>{{ item.VitaminA }}</td>
          <td>{{ item.VitaminB1 }}</td>
          <td>{{ item.VitaminB2 }}</td>
          <td>{{ item.VitaminC }}</td>
          <td>{{ item.Iron }}</td>
          <td>{{ item.Calcium }}</td>
          <td>{{ item.Zinc }}</td>
        </tr>
      </table>
    </el-card>
    <div class="tui-tableTitle"></div>

  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    BookInfo: Object,
  },
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
table {
  width: 100%;
  // min-width: 600px;
  border-collapse: collapse;
}

table caption {
  font-size: 2em;

  font-weight: bold;

  margin: 1em 0;
}

th,
td {
  border: 1px solid #ebeef5;

  text-align: center;

  padding: 20px 0;
}

table thead tr {
  background-color: #008c8c;

  color: #fff;
}

table tbody tr:nth-child(odd) {
  background-color: #eee;
}

table tbody tr:hover {
  background-color: #ccc;
}

table tbody tr td:first-child {
  color: #f40;
}

table tfoot tr td {
  text-align: right;

  padding-right: 20px;
}

.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}

.tui-box {
  width: 382px;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .tui-box-item {
    padding: 0 10px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}

.tui-tableTitle {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  padding: 20px 0;
}
</style>